import { cn } from "@/lib/utils"
import { useStudioStore } from "@/store/studio"

const stages = [
  { key: "develop", label: "Develop", num: "01" },
  { key: "plan", label: "Plan", num: "02" },
  { key: "produce", label: "Produce", num: "03" },
  { key: "finish", label: "Finish", num: "04" },
  { key: "publish", label: "Publish", num: "05" },
]

export default function ProductionRail() {
  const store = useStudioStore()
  const currentView = store.view
  Math.max(2, store.stage * 20)

  return (
    <div className="px-3 sm:px-5 lg:px-6 py-3 sm:py-4 border-b border-[#1e2130] bg-[#08090d]/60">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-[#6b7280]">Production journey</p>
          <p className="text-sm font-medium text-[#f0f1f5] truncate max-w-[65vw]">
            {currentView === "home" ? "Overview" : stages.find((s) => s.key === currentView)?.label || "Overview"}
          </p>
        </div>
        <span className="text-xs text-[#6b7280]">{store.stage} of 5 complete</span>
      </div>

      <div className="flex items-center gap-1 mb-2">
        {stages.map((stage, i) => {
          const done = store.stage > i
          const current = currentView === stage.key
          return (
            <div key={stage.key} className="flex-1 flex items-center gap-1">
              <div
                className={cn(
                  "flex-1 h-1 rounded-full transition-colors",
                  done ? "bg-[#10b981]" : current ? "bg-[#f59e0b]" : "bg-[#1e2130]"
                )}
              />
            </div>
          )
        })}
      </div>

      <div className="flex justify-between">
        {stages.map((stage) => (
          <span key={stage.key} className="text-[10px] text-[#6b7280]">{stage.num}</span>
        ))}
      </div>
    </div>
  )
}
